import styled from 'styled-components';

export const Box = styled.div`
  padding: 15px 0;
  margin-top: 12px;
  margin-bottom: 12px;
  background: ${p => p.theme.backgroundColor};
  width: 100%;
  border-radius: 3px;
  transition: 0.25s opacity ease-in-out;
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  background-color: #fff;
  padding: 5px 20px;
  transition: 0.3s background-color;
  &:hover {
    background-color: #f7f7f7;
  }
`;
